module.exports = __webpack_public_path__ + "static/media/financial-assistance.52095b64.svg";